var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "footer" } }, [
    _c("p", { staticClass: "font-weight-bolder" }, [
      _vm._v("Columbus Metropolitan Library © " + _vm._s(_vm.currentYear)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }